import { render, staticRenderFns } from "./DirectionsCostFerryingBlock.vue?vue&type=template&id=55ca7d51&scoped=true&"
import script from "./DirectionsCostFerryingBlock.vue?vue&type=script&lang=js&"
export * from "./DirectionsCostFerryingBlock.vue?vue&type=script&lang=js&"
import style0 from "./DirectionsCostFerryingBlock.vue?vue&type=style&index=0&id=55ca7d51&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ca7d51",
  null
  
)

export default component.exports